import Vue from 'vue'
import { mapMutations } from 'vuex'
import VueMq from 'vue-mq'
import VueHead from 'vue-head'
import App from './App.vue'
import store from './store'
import router from './router'
import webp from './webp'
import vSelect from 'vue-select'
import Vuelidate from 'vuelidate'
import VueTheMask from 'vue-the-mask'
import transition from '@/transition'
import ChicoBento from '@ciclicbr/chico-bento'
import SentryPlugin from '@ciclicbr/sentry-plugin'
import VueSweetalert2 from 'vue-sweetalert2'
import { datadogRum } from '@datadog/browser-rum'

import info from '../package.json'

import '@ciclicbr/chico-bento/dist/chico-bento.css'
import 'vue-select/dist/vue-select.css'
import '@/style/components/_select.scss'
import 'sweetalert2/dist/sweetalert2.min.css'

// Datadog RUM is only enabled in production
if (!process.env.VUE_APP_ENV) {
  datadogRum.init({
    applicationId: '47300665-d625-4b00-962e-5e1189f37da3',
    clientToken: 'pubb3d049b114675378d8ecc971001fbdcd',
    site: 'datadoghq.com',
    service: 'travel',
    env: process.env.VUE_APP_ENV || process.env.NODE_ENV,
    version: info.version,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    enableExperimentalFeatures: ['clickmap'],
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [process.env.VUE_APP_API_URL, (url) => url.startsWith(process.env.VUE_APP_API_URL)]
  })

  datadogRum.startSessionReplayRecording()
}

Vue.config.productionTip = false
Vue.use(ChicoBento)
Vue.use(Vuelidate)
Vue.use(VueTheMask)
Vue.use(VueHead)
Vue.use(transition)
Vue.use(vSelect)
Vue.use(VueMq, {
  breakpoints: {
    xs: 450,
    sm: 767,
    md: 1250,
    lg: Infinity
  }
})
Vue.use(VueSweetalert2)

Vue.use(SentryPlugin, {
  dsn: 'https://003eaafdf77c4be4bf1e493bd9da547c@o96223.ingest.sentry.io/5513374',
  project: 'travel',
  version: info.version,
  environment: process.env.VUE_APP_ENV || process.env.NODE_ENV,
  ignoreErrors: ['$ is not a function']
})

Vue.prototype.$theme = 'viagem'

if (
  /client_id=(.*)/.test(window.location.href) &&
  /a2g/.test(window.location.href)
) {
  Vue.prototype.$theme = 'a2g'
} else if (/client_id=(.*)/.test(window.location.href)) {
  Vue.prototype.$theme = 'partner'
  Vue.prototype.$clientId = /client_id=([^&,#,/]+)/.exec(
    window.location.href
  )[1]

  if (/partner=(.*)/.test(window.location.href)) {
    Vue.prototype.$partner = /partner=([^&,#,/]+)/.exec(window.location.href)[1]
  }
}

// Inicia variavel partnerBB como false, caso a regexp retorne true na verificacao dos parametros na url,
// seta varivael partnerBB psra true
Vue.prototype.$partnerBB = false
if (
  /utm_source=(bb|bbseguros)&utm_medium=(app|acao-(motor|clientebbseg))&utm_campaign=(seguro_viagem|motordeinteracao|lancamento)/.test(
    window.location.href
  )
) {
  Vue.prototype.$partnerBB = true
}

webp()

new Vue({
  router,
  store,
  render: (h) => h(App),
  created () {
    // Redirect para www.ciclic.com.br/{{params}}, caso usuário esteja vindo sem o www na url
    // if (!/localhost|(staging|bidu)\.ciclic\.com\.br/.test(window.location.href) && !/www\.ciclic\.com\.br/.test(window.location.href)) {
    //   const param = window.location.search || window.location.hash
    //   window.location.replace(`${process.env.VUE_APP_HOME_URL}${param}`)
    // }
    this.changeTheme(this.$theme)
  },
  methods: {
    ...mapMutations('travelSetup', ['changeTheme'])
  }
}).$mount('#app')
